import * as React from 'react';
import {useEffect, useState} from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core';
import {createStyles, makeStyles, Theme, withStyles} from '@material-ui/core/styles';
import {CloseIcon} from 'src/components/privilages/pop-up-window/PopUp';
import {addButtonColor, mainAccordingColor, textColor} from 'src/components/sub-components/colors/colors';
import {TextBar} from 'src/components/sub-components/TextBar';
import {UserRoleAccordingList} from './according-list/UserRoleAccordingList';
import {environment} from 'src/environments/environment';
import { ExpandIcon } from 'src/components/privilages/according-list/AccordingList';


const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    inputGridsLeft: {
      margin: '5px',
    },
    text: {
      marginTop: "10px",
      marginBottom: "5px",
      color: textColor
    },
    tableHeader: {
      backgroundColor: "white",
      color: "black",
      marginTop: "15px",
      paddingTop: "10px",
      paddingBottom: "10px"
    },
    add: {
      backgroundColor: addButtonColor,
      color: "white",
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    },
    cancel: {
      backgroundColor: "white",
      color: "#707070",
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    },
    highPrivilegeAccording: {
      backgroundColor: mainAccordingColor,
      width: "100%",
      marginBottom: "1px",
    },
  })
)

export function UserRolePopUp(props) {
  const classes = useStyles();

  const [userPrivilege, setUserPrivilege] = useState([])
  const [show,setShow] = useState(-1)
  const [allPrivileges,setAllPrivileges] = useState([])
  const [selectAll,setSelectAll] = useState([])
  const [currentPrivileges,setCurrentPrivileges] = useState([])

  //loading state
  const [loading,setLoading] = useState(false)

  const openEdit = (i) => {
    if (i === show) {
      setShow(-1)
    } else {
      setShow(i)
    }
  }

  //getAll privileges function
  let newAllPrivilege =[]
  let allNewPrivileges = []
  const getPrivileges = () => {
    setLoading(true)
    fetch(`${environment.host}/ums/super/user-privileges`,
      {
        method: "GET",
        headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')}
      }).then(response => response.json())
        .then(data => {
        if (data.message === "Success") {

          let actions = []
          data.content.map((privilege) => {
            if(privilege != null){
              if (privilege.actions && Array.isArray(privilege.actions)) {
                privilege.actions.map((action) => {
                  if (!actions.includes(action.action_name)) {
                    actions.push(action.action_name)
                  }
                 }) 
                }    
                if(privilege.child.length == 0){
                  privilege.child.map(c =>{
                    if(c.actions){
                      c.actions.map(a => a.selected =null)
                    }
                  })
                }
            }
            
          })
          
          data.content.map(p =>{
            p.selected = false
            if(p.actions){
              p.actions.map( a => a.selected = false)
            }
            allNewPrivileges.push (p)
            idFinder(p,data.content)
          })
          ids.map(p =>{
            if(p != null){
              p.selected = false
              if(p.actions){
                p.actions.map( a => a.selected = false)
              }
              if(!allNewPrivileges.some(priv => priv.id == p.id)){
                allNewPrivileges.push (p)
              }
            }
            
            
          })
          setSelectAll(allNewPrivileges)
          setAllPrivileges(data.content);
          newAllPrivilege = data.content;
          // setLoading(false)
          if(props.type == 'view'){
            getCurrentPrivilege()
          }
            
          
        } else {
          // setAlertOpen(false)
          // setSeverity("error")
          // setTopic("Error")
          // setMessage(data.message)
          // setLoading(true)
          // setTimeout(() => {
          //   setAlertOpen(false)
          // }, 6000)
        }
      })
  }

  let ids = []
  const idFinder = (privilege, allPrivileges) => {
    allPrivileges.map((p) => {
      if(p != null){
        idFinder(privilege, p.child)
        if(privilege != null){
          if (privilege.id == p.id) {
            privilege.child.map(child =>{
              ids.push(child)
              idFinder(child,privilege.child)
            })         
          }
        }
        
      }
    })
  }

  const getCurrentPrivilege = () =>{
    setLoading(true)
    fetch(`${environment.host}/ums/super/user-role/${props.userRoleId}`,
      {
        method: "GET",
        headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')}
      }).then(response => response.json())
      .then(data => {
        if (data.message === "Success") {
          // console.log(data.content.userPrivileges)
          let newCurrent =[]
          let current =data.content.userPrivileges.sort((a,b)=> b.id - a.id)
          current.forEach(p =>{
            let parent = current.filter(priv => priv.id == parseInt(p.parentId))
            if(p.parentId != 'high-privilege'){
              if(parent.length > 0){
                if(!newCurrent.some(priv => priv.id == p.id)){
                
                  if(!newCurrent.some(p => p.id == parent[0].id)){
                    newCurrent.push(p)
                    newCurrent.push(parent[0])
                  }else{
                    let parentIndex = newCurrent.findIndex(p => p.id == parent[0].id)
                    newCurrent.splice(parentIndex,0,p)
                  }
                  
                }else{
                  if(!newCurrent.some(p => p.id == parent[0].id)){
                    newCurrent.push(parent[0])
                  }
                }
              }
            }else{
              if(!newCurrent.some(priv => priv.id == p.id)){
                newCurrent.push(p)
              }
            }
          })
          newCurrent.map((p,index) => {
              if(p.child.length > 0){
                p.child.map((child,index) =>{
                  if(data.content.userPrivileges.some(p => p.id === child.id)){
                    let matchChildPrivilege = data.content.userPrivileges.filter(p => p.id === child.id)
                    p.child[index] = matchChildPrivilege[0]
                  }else{
                    child.selected = false
                  }
                })
                const allChildSelect = p.child.every(p => p.selected == true)
                const partiallySelect = p.child.some(p => p.selected == true || p.selected == 'partial');

                //find actions selection
                if(p.actions){
                  
                  if(p.actions.every(a => a.selected == true)){
                    if(allChildSelect){
                      p.selected = true
                    }else {
                      p.selected = 'partial'
                    }
                  }else{
                    p.selected = 'partial'
                  }
                }else{
                  if(allChildSelect){
                    p.selected = true
                    
                  }else if(partiallySelect){
                    p.selected = 'partial'
                  }
                }
              }else{
                if(p.actions){
                  if(p.actions.every(a => a.selected == true)){
                    p.selected = true
                  }else if(p.actions.some(a => a.selected == true)){
                    p.selected = 'partial'
                  }
                }
                
              }
            
              newCurrent[index] = p
          })
          setCurrentPrivileges(newCurrent)
          
          let newData = newAllPrivilege.map(p => {
            let matchedUserPrivilege = newCurrent.filter(cp => cp.id === p.id);
            if (matchedUserPrivilege.length > 0) {
              let matchActions
              if(matchedUserPrivilege[0].actions){
                matchActions = matchedUserPrivilege[0].actions.filter(action =>{
                  return p.actions.some(pAction => pAction.action_name === action.action_name)
                })
              }
              matchedUserPrivilege[0].actions = matchActions
              return matchedUserPrivilege[0];
            }else {
              p.selected = false
              return p;
            }
          });
          setAllPrivileges(newData)
          setLoading(false)
        } else {
          setLoading(false)
          // setAlertOpen(true)
          // setSeverity("error")
          // setTopic("Error")
          // setMessage(data.message)
          // setTimeout(() => {
          //   setAlertOpen(false)
          // }, 6000)
        }
      })
  
  }

  useEffect(() => {
    getPrivileges()
    
  }, [props.open])
  return (
    <Dialog open={props.open} maxWidth="md">
      <Grid container>
        <Grid item xs={10} md={10}>
          <DialogTitle>View User Privilege Details</DialogTitle>
        </Grid>
        <Grid item xs={2} md={2} style={{textAlign: "right"}}>
          <IconButton onClick={() => {
            props.onClose()
          }}>
            <CloseIcon/>
          </IconButton>
        </Grid>
      </Grid>

      <Divider/>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} md={5} className={classes.inputGridsLeft}>
            <Typography className={classes.text}>Role ID</Typography>
            <TextBar defaultValue={props.userRoleId} width="100%" type="text" error={{error: false, errorMsg: ""}}/>
          </Grid>
          <Grid item xs={12} md={5} className={classes.inputGridsLeft}>
            <Typography className={classes.text}>Role Name</Typography>
            <TextBar defaultValue={props.userName} width="100%" type="text" error={{error: false, errorMsg: ""}}/>
          </Grid>
          <Grid item xs={12} md={12} className={classes.inputGridsLeft}>
            <Typography className={classes.text}>Role Description</Typography>
            <TextBar defaultValue={props.description} width="100%" type="text" error={{error: false, errorMsg: ""}}/>
          </Grid>

          <Grid container className={classes.tableHeader}>
            <Grid item xs={6} md={6} style={{textAlign: "center"}}>
              <Typography style={{fontWeight: "bold"}}>PRIVILEGES</Typography>
            </Grid>
            <Grid item xs={6} md={6} style={{textAlign: "center"}}>
              <Typography style={{fontWeight: "bold"}}>ACTIONS</Typography>
            </Grid>
          </Grid>

          <Grid container>
            {
              allPrivileges.length === 0 ? (
                <Typography style={{ textAlign: 'center', margin: 'auto', marginBottom: '20px', width: '50%' }}>No privileges available</Typography>
              ) : (
                allPrivileges.map((privilege, index) => (
                  <CustomAccordion key={index} elevation={0} TransitionProps={{ unmountOnExit: true }} className={classes.highPrivilegeAccording} expanded={index == show}>
                    <AccordionSummary expandIcon = {privilege.child.length>0 ? <ExpandIcon/> : <></>} onClick={()=>openEdit(index)} style={{paddingRight:privilege.child.length == 0? '30px':'0px'}}>
                      <Grid container>
                        <Grid item xs={1} md={1}>
                        <Checkbox style={{color: "rgba(24, 29, 51,0.63)"}}
                                              
                                              checked={privilege.selected == true }
                                              onClick={(e) => e.stopPropagation()}
                                              indeterminate={(privilege.selected == 'partial' )}
                                              disabled ={true}/>
                        </Grid>
                        <Grid item xs={3} md={3}>
                          <Tooltip title={privilege.name} placement="bottom-start" arrow>
                            <Typography>{privilege.name.length > 15 ? privilege.name.substring(0, 15) + "..." : privilege.name}</Typography>
                          </Tooltip>
                        </Grid>
                        <Grid item key={index} md={8} xs={8} style={{display:'flex',overflowX:'auto'}}>
                                  {privilege.actions?
                                    privilege.actions.map((action,actionIndex) =>{ 
                                      return <Grid key={actionIndex} item md={8} xs={8} style={{display:'flex',alignItems:'center',fontFamily:'Roboto, Helvetica, Arial, sans-serif',marginRight:'10px'}}>
                                        <Checkbox style={{color: "rgba(24, 29, 51,0.63)"}}
                                          checked={action.selected || false}
                                          disabled={true}
                                          onClick={(e)=>e.stopPropagation()}/>
                                        <Grid style={{fontFamily:'Roboto, Helvetica, Arial, sans-serif'}}>{action.action_name}</Grid>
                                      </Grid>
                                    }):<></>
                                    
                                  }
                                  </Grid>

                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails style={{ backgroundColor: "white", paddingBottom: "0px", padding: "0px" }}>
                      <UserRoleAccordingList data={privilege.child} opacity={0.25} padding={1} />
                    </AccordionDetails>
                  </CustomAccordion>
                ))
              )
            }

          </Grid>

        </Grid>
        {loading &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80}/>
        </div>
      }
      </DialogContent>
    </Dialog>
  )
}

const CustomAccordion = withStyles({
  root: {
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(Accordion);

export const CheckBoxIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
         fill="rgba(24, 29, 51, 0.64)">
      <path d="M0 0h24v24H0V0z" fill="none"/>
      <path
        d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"/>
    </svg>
  )
}
